import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        CurrentPassword: '',
        Password: '',
        PasswordConfirmation: '',
    },

    actions: {
        update({ state }) {
            return axios.put('/api/contacts/password', state);
        },
    },

    mutations: {
        updateField,
    },

    getters: {
        getField,
    },
};
